import { render, staticRenderFns } from "./RefundCollectingForm.vue?vue&type=template&id=4bddf785"
import script from "./RefundCollectingForm.vue?vue&type=script&lang=js"
export * from "./RefundCollectingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports